import type { ButtonHTMLAttributes } from 'react';
import { cx } from '@/core/utils';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** Filled accent button for the main action of a context. */
  primary?: boolean;
};

export function Button({ className, primary, type = 'button', ...props }: Props) {
  return (
    <button
      type={type}
      className={cx(
        'inline-flex min-h-10 cursor-pointer items-center justify-center rounded-lg border px-3 font-medium select-none disabled:cursor-default disabled:opacity-40 md:min-h-8',
        primary
          ? 'border-accent bg-accent text-white hover:bg-accent-strong active:bg-accent-strong'
          : 'border-neutral-300 bg-white hover:bg-neutral-100 active:bg-neutral-200',
        className,
      )}
      {...props}
    />
  );
}
